export default "__VITE_ASSET__DhzIwWKM__"